// extracted by mini-css-extract-plugin
export default {"colourPicker":"styles_colourPicker__YnziO","popover":"styles_popover__oHPeR","cover":"styles_cover__WUiEP"};